import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PipesModule } from '@core/pipes/pipes.module';
import { TranslateModule } from '@ngx-translate/core';
import { OnUiButtonModule, OnUiCardMenuModule, OnUiCoverModule } from 'onclass-ui';
import { UserServiceCardComponent } from './user-service-card.component';

@NgModule({
  declarations: [UserServiceCardComponent],
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    OnUiCardMenuModule,
    OnUiCoverModule,
    OnUiButtonModule,
    PipesModule,
  ],
  exports: [UserServiceCardComponent],
})
export class UserServiceCardModule {}
